export const inboxesConstants = {
  INBOXES_REQUEST: 'INBOXES_REQUEST',
  INBOXES_SUCCESS: 'INBOXES_SUCCESS',
  INBOXES_ERROR: 'INBOXES_ERROR',
};
